import { render, staticRenderFns } from "./IncludedPage.vue?vue&type=template&id=bdfafb40&scoped=true&"
import script from "./IncludedPage.vue?vue&type=script&lang=js&"
export * from "./IncludedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdfafb40",
  null
  
)

export default component.exports